/// <reference no-default-lib="true"/>
/* eslint-disable */

import { format, parseISO, } from 'date-fns';

export default function DateHora({ date }) {
    if (!date) return null;

    const dataSemZ = date.replace('Z', '');

    return (
        <span>
            {/* {format(parseISO(date), 'dd-MM-yyyy HH:mm:ss')} */}
            {format(new Date(dataSemZ), 'dd-MM-yyyy HH:mm:ss')} 
        </span>
    )
} 